import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Error404 from '../../Page/Error404';
import DashboardPage from '../../Page/DashboardPage';
import ManageOrders from '../../Page/ManageOrders';
import ManagePayments from '../../Page/ManagePayments';
import ManageReports from '../../Page/ManageReports';
import Profile from '../../Page/Profile';
import MenuPage from '../../Page/MenuPage';
import FoodCat from '../../Page/FoodCat';
import ManageDrink from '../../Page/ManageDrink';
import BillHistory from '../../Page/Bill/BillHistory';
import Zone from '../../Page/Zone';
import Inventory from '../../Page/Inventory';
import Supplier from '../../Page/supplier';
import Vendor from '../../Page/vendor';
import InHouseExpenses from '../../Page/InHouseExpenses';
import ManageExpese from '../../Page/ManageExpense';
import FoodstockPage from '../../Page/FoodstockPage';
import PdfConfig from '../../Page/PdfConfig';

import ManageTable from '../../Page/ManageTable';
import ManageBillsNoContext from '../../Page/ManageBillsNoContext';
import TablesBillsNoContext from '../../components/biils/TablesBillsNoContext';
import TableReport from '../../Pages/Manage/Users/reports/TableReport';
import BillReport from '../../Pages/Manage/Users/reports/BillReport';
import StockReport from '../../Pages/Manage/Users/reports/StockReport';

import FoodStockReport from '../../Pages/Manage/Users/reports/FoodStockReport';
import SalesReport from '../../Pages/Manage/Users/reports/SalesReport'

import LoginPage from '../../Page/LoginPage';
import ProtectedRoute from './ProtectedRoute';

// create these pages
import ManageUser from '../../Page/ManageUser';
import UserPermission from '../../Page/UserPermission';
import GeneralSettings from '../../Page/GeneralSettings';
import ParcelItemReport from '../../Pages/Manage/Users/reports/ParcelItemReport';
import DrinkCat from '../../Page/DrinkCat';
import DrinkItemReport from '../../Pages/Manage/Users/reports/DrinkItemReport';
import RoomService from '../../Page/RoomService';
import ManageRestaurants from '../../Page/ManageRestaurants';

const allRoutes = [
  { url: '/manage-restaurants', moduleKey: 'manage_restaurants', component: <ManageRestaurants /> },
  { url: '/dashboard', moduleKey: 'dashboard', component: <DashboardPage /> },
  { url: '/manage-orders', moduleKey: 'manage_orders', component: <ManageOrders /> },
  { url: '/manage-payments', moduleKey: 'manage_payments', component: <ManagePayments /> },
  { url: '/manage-report', moduleKey: 'manage_report', component: <ManageReports /> },
  { url: '/profile', moduleKey: 'profile', component: <Profile /> },
  { url: '/manage-menu', moduleKey: 'manage_menu', component: <MenuPage /> },
  { url: '/food-category', moduleKey: 'food_category', component: <FoodCat /> },
  { url: '/drinks-category', moduleKey: 'drink_category', component: <DrinkCat /> },
  { url: '/manage-drink', moduleKey: 'manage_drink', component: <ManageDrink /> },
  { url: '/manage-bills', moduleKey: 'manage_bills', component: <ManageBillsNoContext /> },
  { url: '/tables-bills', moduleKey: 'manage_bills', component: <TablesBillsNoContext /> },
  { url: '/bill-history', moduleKey: 'bill_history', component: <BillHistory /> },
  { url: '/zone', moduleKey: 'zone', component: <Zone /> },
  { url: '/inventory', moduleKey: 'inventory', component: <Inventory /> },
  { url: '/supplier', moduleKey: 'supplier', component: <Supplier /> },
  { url: '/vendor', moduleKey: 'vendor', component: <Vendor /> },
  { url: '/In-House-Expenses', moduleKey: 'in_house_expenses', component: <InHouseExpenses /> },
  { url: '/manage-expense', moduleKey: 'manage_expense', component: <ManageExpese /> },
  { url: '/food-stock-spent', moduleKey: 'food_stock_spent', component: <FoodstockPage /> },
  { url: '/pdf-config', moduleKey: 'pdf_config', component: <PdfConfig /> },

  { url: '/manage-table', moduleKey: 'manage_table', component: <ManageTable /> },
  { url: '/room-service', moduleKey: 'room_service', component: <RoomService /> },
  { url: '/report/tables', moduleKey: 'table_report', component: <TableReport /> },
  { url: '/report/parcel-items', moduleKey: 'parcel_item_report', component: <ParcelItemReport /> },
  { url: '/report/drink-items', moduleKey: 'drink_item_report', component: <DrinkItemReport /> },

  { url: '/report/bills', moduleKey: 'bill_report', component: <BillReport /> },
  { url: '/report/stock', moduleKey: 'stock_report', component: <StockReport/>},
  { url: '/report/foodstock', moduleKey: 'food_stock_report', component: <FoodStockReport/>},


    { url: '/report/sales', moduleKey: 'sales_report', component: <SalesReport/>},


  { url: '/manage-user', moduleKey: 'manage_user', component: <ManageUser /> },
  { url: '/user-permission', moduleKey: 'user_permission', component: <UserPermission /> },
  { url: '/general-settings', moduleKey: 'general_settings', component: <GeneralSettings /> },
];

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<LoginPage />} />

      {allRoutes.map((route) => (
        <Route
          key={route.url}
          path={route.url}
          element={
             <ProtectedRoute moduleKey={route.moduleKey} action="view">
              {route.component}
            </ProtectedRoute>
          }
        />
      ))}

      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};

export default AppRoutes;
